var acStatsCount = acStatsCount || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F();
        };
    })();
}

jQuery(function ( $ ) {
 
    $.fn.statCount = function( options ) {
        return this.each(function() {
            var statCount = Object.create(acStatsCount.statCount);
            statCount.init(this, options);
        });
    };

    $.fn.statCount.options = {

     };

    acStatsCount.statCount = {

        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);
            self.$slider = self.$container.find(".landing-stats__slider");
            self.$counter = self.$container.find(".landing-stats__number");

            self.$settings = {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1, 
            };

            self.bindElements();
        },

        bindElements () {
            var self = this;

            self.$waypoint = self.$container.waypoint(function(direction) {
                if ( direction === 'down') {
                    if (!self.$slider.hasClass('slick-initialized')) {
                        self._triggerAll();
                    }
                    // Destroy breakpoint after initialized animation
                    this.destroy();
                }  
                }, {
                    offset: 'bottom-in-view'
            });

            $(window).on('resize', function() {
                if ($(window).width() <= 768) {
                    if (!self.$slider.hasClass('slick-initialized')) {
                         self.setSlider()
                    }
                } else {
                    if (self.$slider.hasClass('slick-initialized')) {
                        self.$slider.slick('unslick');
                    }
                }
            }).trigger("resize");
        },
        // Set and reset Slider based on breakpoint
        setSlider () {
            var self = this;
            self.$slider.on("init", function(e, slick) {
                var counter = $(slick.$slides[0]).find(self.$counter)
                
                self.$counter.each( function(i) {
                    self._counter( $(this), i );
                });

            });

            self.$slider.slick( self.$settings );
        },
        // Trigger Counter for Single event
        _counter(item, timing) {
            var timer = timing * 500;

            setTimeout(function() {
                $(item).prop("Counter", 0).animate({
                    Counter: $(item).data("count")
                    }, {
                    duration: 1000,
                    easing: 'linear',
                    step: function (now) {
                        $(item).text(Math.ceil(now) );
                    }
                });
            }, timer );

        },
        // Trigger Counter on All
        _triggerAll(e) {
            var self = this;
            self.$counter.each( function(i) {
                self._counter( $(this), i );
            });
        }
    }
});
